import { useState, useCallback } from 'react';

export interface PendingChange {
    nodeId: string;
    paramKey: string;
    newValue: number | boolean | string;
}

export function useQuickTuneState() {
    const [pendingChanges, setPendingChanges] = useState<Map<string, PendingChange>>(new Map());

    const addChange = useCallback((nodeId: string, paramKey: string, newValue: number | boolean | string) => {
        const changeKey = `${nodeId}:${paramKey}`;
        setPendingChanges(prev => {
            const updated = new Map(prev);
            updated.set(changeKey, { nodeId, paramKey, newValue });
            return updated;
        });
    }, []);

    const resetChanges = useCallback(() => {
        setPendingChanges(new Map());
    }, []);

    const getChangesList = useCallback(() => {
        return Array.from(pendingChanges.values());
    }, [pendingChanges]);

    const hasChanges = pendingChanges.size > 0;

    return {
        pendingChanges,
        addChange,
        resetChanges,
        getChangesList,
        hasChanges
    };
}
